var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{ref:"map",staticStyle:{"height":"500px","z-index":"0"},attrs:{"lazy":"","zoom":_vm.zoom,"center":_vm.formatCoordinates(_vm.coordinates)}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_c('l-marker',{attrs:{"lat-lng":_vm.formatCoordinates(_vm.coordinates)}},[_c('l-popup',{attrs:{"minWidth":100}},[_vm._v(_vm._s(_vm.coordinates))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }